const MODULE_NAME = 'demo';
export const selectDataList = (state) => state[MODULE_NAME].dataList;
export const selectDataAgGrid = (state) => state[MODULE_NAME].dataAgGrid;
export const selectDataPivot = (state) => state[MODULE_NAME].dataPivot;
